import { render } from "./BaseButtonLargeIcon.vue?vue&type=template&id=036551cf"
import script from "./BaseButtonLargeIcon.vue?vue&type=script&lang=js"
export * from "./BaseButtonLargeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__